import React, {useEffect} from "react";
import {Dialog, DialogContent} from "@mui/material";
import {Authenticator} from "@aws-amplify/ui-react";
import {Transition} from "../transition/Transition";
import {AuthHeader} from "./AuthHeader";
import "../../theme/amplify-overrides.css";
import "./SignInDialog.css";

// Authenticator renders its children only once the visitor is authenticated,
// so mounting this is the signal that sign-in succeeded.
function OnAuthenticated({onSignedIn}: {onSignedIn: () => void}) {
  useEffect(() => {
    onSignedIn()
  }, [onSignedIn])
  return null
}

type SignInDialogProps = {
  onClose: () => void
  // Fired once sign-in succeeds, so the caller can resume what was interrupted.
  onSignedIn: () => void
}

export function SignInDialog({onClose, onSignedIn}: SignInDialogProps) {
  return (
    <Dialog
      fullWidth={true}
      open={true}
      onClose={onClose}
      TransitionComponent={Transition}
      className="SignInDialog"
    >
      <DialogContent>
        <Authenticator
          loginMechanisms={["username", "email"]}
          components={{Header: AuthHeader}}
        >
          {() => <OnAuthenticated onSignedIn={onSignedIn}/>}
        </Authenticator>
      </DialogContent>
    </Dialog>
  )
}
